<template>
<div v-if="active" class="admin-add-symbol-box">
    <div class="admin-add-symbol-box-header">
        <div class="admin-add-symbol-box-header-text"><strong>Add New Combo Symbol</strong></div>
        <span class="fa-stack fa-xs header-close" @mousedown="hidePopup($event)">
            <i class="fas fa-circle fa-stack-2x"></i>
            <i class="fas fa-times fa-stack-1x fa-inverse"></i>
        </span>
    </div>
    <div class="admin-add-combo-symbol-box-container">
        <div class="input-content">
            <span>Name</span>
            <input type="text" v-virtual-keyboard class="popup-input-symbol-name" placeholder="Enter Name..." v-model="symbol.name" />
        </div>
        <div class="input-content">
            <span>Description</span>
            <input type="text" v-virtual-keyboard class="popup-input-description" placeholder="Enter Description..." v-model="symbol.description" />
        </div>
        <div class="input-content">
            <span>Symbols</span>
            <div class="symbols-checkbox-container">
                <div class="symbol-checkbox-row" v-for="symbol in symbols" :key="symbol.id">
                    {{symbol.name}} [{{symbol.abbreviation}}]
                    <div class="markups-checkbox">
                        <input type="checkbox" 
                        :id="'combo-symbol-checkbox-'+symbol.id"
                        :checked="subSymbols.includes(symbol)"  
                        @change="onCheckChanged($event, symbol)">
                        <label :for="'combo-symbol-checkbox-'+symbol.id"></label>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="admin-add-symbol-box-footer">
        <div class="decide-btn deny" @click="hidePopup()">
            <p>Cancel</p>
        </div>
        <div class="decide-btn confirm" @click="onSubmit()">
            <p>Add Combo Symbol</p>
        </div>
    </div>
</div>
</template>

<script>
import $ from 'jquery';
import { saveMarkupSymbol } from '@/utils/mongoUtils';
export default {
    name: 'AdminComboSymbolsUpload',
    data() {
        return {
            active: false,
            folder:{path:''},
            symbol: {},
            subSymbols:[],
        }
    },

    mounted(){
        this.resetForm();
    },

    methods: {
        hidePopup() {
            this.active = false;
            this.resetForm();
        },
        resetForm(){
            this.symbol ={
                name: "",
                abbreviation: "",
                description: "",
                isSequential: false,
                isTestBlind: false,
                isCombo: true,
            }
            this.subSymbols = [];
            $('.admin-add-combo-symbol-box-container .input-content .popup-input-symbol-name').removeClass('invalid');
            $('.admin-add-combo-symbol-box-container .input-content .popup-input-abbreviation').removeClass('invalid');
        },
        onCheckChanged($event, symbol){
            var _this = this;
            
            if (symbol) {
                if (_this.subSymbols.includes(symbol)) {
                    _this.subSymbols.pop(symbol);
                }else{
                    _this.subSymbols.push(symbol);
                }
            }
        },
        onSubmit() {
            var _this = this;
            var symbol = _this.symbol;

            var isValid = true;

            if (symbol.name == "") {
                $('.admin-add-combo-symbol-box-container .input-content .popup-input-symbol-name')?.addClass('invalid')
                isValid = false;
            }

            if (_this.subSymbols.length < 2) {
                isValid = false;
            }

            if (isValid) {
                symbol.isCombo = true;
                symbol.folderPath= _this.folder.path;
                symbol.subSymbols= _this.subSymbols.map((subSymbol)=>{
                    subSymbol = {
                        subSymbolId : subSymbol.id,
                        abbreviation: subSymbol.abbreviation
                    }
                    return subSymbol;
                });
                symbol.abbreviation = symbol.subSymbols.map(x=>x.abbreviation).join(', ');
                var symbolFromDB = saveMarkupSymbol(symbol);
                _this.folder.symbols.push(symbolFromDB);
                _this.$store.state.MARKUPS.markupSymbols.push(symbolFromDB);
                _this.hidePopup();
            }
        }
    },

    computed: {
        symbols: function(){
            var symbols = this.$store.getters['getMarkupSymbols'];
            return symbols.filter(x=>x.isCombo==false);
        }
    }
}
</script>

<style>
.admin-add-symbol-box {
    position: absolute;
    top: calc(50% - 250Px);
    left: calc(50% - 175Px);
    background-color: #FFFFFF;
    width: 350px;
    height: 500px;
    padding: 25px;
    border-radius: 7px;
    box-shadow: 0 3px 30px -2px rgb(0 0 0 / 10%), 0 2px 2px 0 rgb(0 0 0 / 10%), 0 1px 30px 0 rgb(0 0 0 / 30%);
    animation-name: animatetop;
    animation-duration: 0.4s;
    z-index: 9999;
    user-select: none;
    display: flex;
    flex-direction: column;
}

.admin-add-symbol-box-header {
    width: 100%;
    margin-top: 5px;
    min-height: 20px;
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    color: #333333;
}

.admin-add-symbol-box-header-text {
    width: 70%;
    left: 0px;
    font-family: var(--main-font);
    font-size: 16px;
    font-weight: 800;
    line-height: 24px;
    letter-spacing: -0.25px;
    text-align: left;
    color: var(--primary-color);
}

.header-close .fa-circle {
    color: #BDBDBD;
}

.header-close .fa-times:hover {
    color: var(--dark-primary-color);
}

.admin-add-combo-symbol-box-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
}

.admin-add-combo-symbol-box-container .input-content {
    margin-top: 20px;
}

.admin-add-combo-symbol-box-container .input-content input::placeholder {
    color: #E0E0E0;
}

.admin-add-combo-symbol-box-container .input-content input {
    border: 1px solid #E0E0E0;
    border-radius: 6px;
}

.admin-add-combo-symbol-box-container .input-content input.invalid {
    background-color: ivory;
    outline: 2px solid red;
    border: none;
}

.admin-add-combo-symbol-box-container .input-content span{
    padding-bottom: 7px;
    color: #4F4F4F;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 14px;
    letter-spacing: -0.01em;
    font-weight: bold;
}

.symbols-checkbox-container{
    height: 180px;
    width: 100%;
    overflow: scroll;
}

.symbol-checkbox-row{
    display: flex;
    justify-content: space-between;
    width: 95%;
    height: 35px;
}
.admin-add-symbol-box-footer{
    display: flex;
    justify-content: space-evenly;
    margin-top:25px;
}

.admin-add-symbol-box-footer .decide-btn{
    height: 50px;
    width: 50%;
    margin: 5px;
    border-radius: 5px;
    font-family: var(--main-font);
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    line-height: normal;
    cursor: pointer;
}

.admin-add-symbol-box-footer .decide-btn.confirm{
    background: var(--primary-color);
    color: white;
}

.admin-add-symbol-box-footer .decide-btn.deny{
    color: #BDBDBD;
    border: 1px solid #BDBDBD;
}
</style>
